import {UserDetailsMinRes} from '../cp';
import {Type} from 'class-transformer';
import {FileUploadRes} from '@yasc/yasc-material-components';

export class ArticleResponse {
    public readonly guid!: string;
    public readonly createdAt!: Date;
    public readonly updatedAt!: Date;
    @Type(() => UserDetailsMinRes)
    public readonly createdBy: UserDetailsMinRes = new UserDetailsMinRes();
    @Type(() => UserDetailsMinRes)
    public readonly updatedBy: UserDetailsMinRes = new UserDetailsMinRes();
    public brand!: string;
    @Type(() => FileUploadRes)
    public productImage: FileUploadRes | null = null;
    public model!: string;
    public modelNumber!: string;
    public modelCategory!: string;
    public weight!: number;
    public dimensions!: string;
    public manufactureDate!: Date;
    public modelDescription!: string;
    public link!: string;
    public warranty!: number;

    public clone(response: ArticleResponse): ArticleResponse {
        let responseClone = new ArticleResponse();

        if(responseClone.brand!) {responseClone.brand = response.brand;}
        responseClone.productImage = response.productImage;
        responseClone.model = response.model;
        responseClone.modelNumber = response.modelNumber;
        responseClone.modelCategory = response.modelCategory;
        responseClone.weight = response.weight;
        responseClone.dimensions = response.dimensions;
        responseClone.manufactureDate = response.manufactureDate;
        responseClone.modelDescription = response.modelDescription;
        responseClone.link = response.link;
        responseClone.warranty = response.warranty;

        return responseClone;
    }

    public combine(responseList: ArticleResponse[]): ArticleResponse {
        let responseCombine = new ArticleResponse();

        let firstEntry = false;
        responseList.forEach((element) => {
            if(firstEntry)  {
                responseCombine.clone(element);
            }

            if(responseCombine.brand !== element.brand) { responseCombine.brand = "";}
            if(responseCombine.productImage !== element.productImage) { responseCombine.productImage = null;}
            if(responseCombine.model !== element.model) { responseCombine.model = "";}
            if(responseCombine.modelNumber !== element.modelNumber) { responseCombine.modelNumber = "";}
            if(responseCombine.modelCategory !== element.modelCategory) { responseCombine.modelCategory = "";}
            if(responseCombine.weight !== element.weight) { responseCombine.weight = 0;}
            if(responseCombine.dimensions !== element.dimensions) { responseCombine.dimensions = "";}
            if(responseCombine.manufactureDate !== element.manufactureDate) { responseCombine.manufactureDate = new Date();}
            if(responseCombine.modelDescription !== element.modelDescription) { responseCombine.modelDescription = "";}
            if(responseCombine.link !== element.link) { responseCombine.link = "";}
            if(responseCombine.warranty !== element.warranty) { responseCombine.warranty = 0;}
        });

        return responseCombine;
    }


}

export class ArticleUpdateReq {
    public guid?: string;
    public createdAt?: Date;
    public updatedAt?: Date;
    public createdBy?: number;
    public updatedBy?: number;
    public brand?: string;
    public productImage?: string;
    public model?: string;
    public modelNumber?: string;
    public modelCategory?: string;
    public weight?: number;
    public dimensions?: string;
    public manufactureDate?: Date;
    public modelDescription?: string;
    public link?: string;
    public warranty?: number;

    public fromResponse(response: ArticleResponse): ArticleUpdateReq {
        let request = new ArticleUpdateReq();

        request.guid = response.guid;
        request.createdAt = response.createdAt;
        request.updatedAt = response.updatedAt;
        request.createdBy = response.createdBy.id;
        request.updatedBy = response.updatedBy.id;
        request.brand = response.brand;
        request.productImage = response.productImage?.id;
        request.model = response.model;
        request.modelNumber = response.modelNumber;
        request.modelCategory = response.modelCategory;
        request.weight = response.weight;
        request.dimensions = response.dimensions;
        request.manufactureDate = response.manufactureDate;
        request.modelDescription = response.modelDescription;
        request.link = response.link;
        request.warranty = response.warranty;

        return request;
    }
}

export class ArticleCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
